// Fire-and-forget funnel event tracker. Persists a stable session_id in
// localStorage so unique users can be counted across page loads.
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const SESSION_KEY = 'verilock_funnel_session';

function getSessionId() {
  try {
    let id = localStorage.getItem(SESSION_KEY);
    if (!id) {
      id = `s_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return null;
  }
}

const FIRED_THIS_TAB = new Set();

/**
 * Track a funnel event. De-duplicates per browser tab per event name
 * (composite key includes properties so taps on different cards each fire).
 *
 * @param {string} eventName one of the canonical funnel names
 * @param {object} [opts]
 * @param {boolean} [opts.allowRepeat] - bypass per-tab dedup (rare)
 * @param {object} [opts.properties] - optional scalar properties to record
 */
export function trackFunnel(eventName, opts = {}) {
  if (!eventName) return;
  const dedupKey = opts.properties
    ? `${eventName}|${JSON.stringify(opts.properties)}`
    : eventName;
  if (!opts.allowRepeat && FIRED_THIS_TAB.has(dedupKey)) return;
  FIRED_THIS_TAB.add(dedupKey);

  // Strip Authorization so unauthenticated steps (pre-login) aren't blocked by
  // proxies and so auth state never affects the tracking outcome.
  axios
    .post(
      `${BACKEND_URL}/api/funnel/track`,
      {
        event_name: eventName,
        session_id: getSessionId(),
        ...(opts.properties ? { properties: opts.properties } : {}),
      },
      {
        transformRequest: [(data, headers) => {
          if (headers) delete headers.Authorization;
          return JSON.stringify(data);
        }],
        headers: { 'Content-Type': 'application/json' },
        withCredentials: false,
      }
    )
    .catch(() => {});
}
